import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as myGlobals from './../../../../globals/constants';
import * as globalFunctions from './../../../../globals/functions';
import { Observable } from 'rxjs';
import { DialogConfig, DialogRef, DialogService } from 'app/shared/dialog';
import { AccountStatus, APIService, AuthorizationLevel, CreateUserInput, CustomPropertyDefinitions, InviteUserInput, ModelAccountMembershipFilterInput, UpdateAccountMembershipAction, UpdateAccountMembershipInput } from './../../../API.service.custom';
import { ToastrService } from 'ngx-toastr';
import { AccountMembership } from './../../../../app/API.service.custom'
import { DataShareService } from './../../../../services/data-share.service'
import { AuthService } from '../../../auth/auth.service';
import { AddEmployeeBulkComponent } from '../add-employee-bulk/add-employee-bulk.component';
import { cloneDeep } from 'lodash-es'
import { UploadDoneService } from '../../upload/upload-done-service';
import { SearchCountryField, CountryISO, PhoneNumberFormat, NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { Dictionary } from 'lodash-es';
import _ from 'lodash-es';
import { MatButton } from '@angular/material/button';
import { RenderCustomPropertiesComponent } from '../../render-custom-properties/render-custom-properties.component';
import { MatError, MatFormField } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { TitleCasePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { fetchAllUsersByAccount } from '../../account/users-by-account-pagination';

@Component({
    selector: 'app-add-employee',
    templateUrl: './add-employee.component.html',
    styleUrls: ['./add-employee.component.scss'],
    imports: [MatButton, RenderCustomPropertiesComponent, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, MatError, MatFormField, MatInput, MatSlideToggle, TitleCasePipe]
})

export class AddEmployeeComponent implements OnInit {

  activAccountSubscription;

  addEmployeeForm: UntypedFormGroup;
  formSubmitted = false;
  isNotDuplicateEmployee = false;
  activeAccount: AccountMembership = null;
  accountStatus : string = null;
  authorizations = [];

  emailregex = myGlobals.emailregex;
  mobileregex = myGlobals.mobileregex;
  pincoderegex = myGlobals.pincoderegex;

  memberToEdit : AccountMembership = null;
  inEditMode = false;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.India, CountryISO.UnitedStates];
  
  customProperties: CustomPropertyDefinitions[] = [];
  allPropertiesSubscription;
  allCustomProps : Dictionary<CustomPropertyDefinitions> = {};
  customAttributes = null;


  constructor(private formBuilder: UntypedFormBuilder,
    private api: APIService,
    private config: DialogConfig,
    private dialog: DialogRef,
    private toastr: ToastrService,
    private dataService: DataShareService,
    private auth: AuthService,
    private sidebarService: DialogService,
    private data: UploadDoneService, 
  ) { }

  createForm() {
    this.addEmployeeForm = this.formBuilder.group({
      invitedUser: this.formBuilder.group({
        // name: [null, [Validators.required]],
        registeredNumber: [null, {
          validators: [Validators.required]
        }],
        registeredEmail: [null, {
          validators: [Validators.pattern(this.emailregex), Validators.required],
          updateOn: 'blur'
        }]
      }),
      invitedUserAuthorizationLevel: ['MEMBER', [Validators.required]],
    })
  }

  checkInUseMobile(control) {
    // mimic http database access
    console.log('Call to checkInUseMobile');
    const db = ['988633922566878'];
    return new Observable(observer => {
      setTimeout(() => {
        const result = (db.indexOf(control.value) !== -1) ? { alreadyInUse: true } : null;
        observer.next(result);
        observer.complete();
      }, 400);
    });

  }

  checkIfNotDuplicate() {
    if(!this.inEditMode){
    let control = this.addEmployeeForm.get('invitedUser').get('registeredNumber');
    console.log("Value of number is :", control.value)
    if (!control.errors) {
      console.log('inside check if not duplicate');
      let phoneNumber = control.value;
      if(control.value.e164Number)
        phoneNumber = control.value.e164Number;
      let filter = { or: [{ userAccountPrimaryNumber: { eq: phoneNumber } }, { userAccountSecondaryNumber: { eq: phoneNumber } }] }
      this.api.GetAuthorizationByUserAccount(this.activeAccount.accountId, null, null, filter).then((data: any) => {
        console.log(data);
        if (data && data.items && data.items.length > 0) {
          this.isNotDuplicateEmployee = false;
          control.setErrors({ alreadyInUse: true });
        } else {
          this.isNotDuplicateEmployee = true;
          control.setErrors(null);
        }
      })
        .catch(e => {
          console.log('error checking duplicate', e);
          this.showErrorInToastr(e, 'Error Checking Duplicate')
        });
    }
  }
  }


  ngOnInit() {
    this.createForm();
    let inviteNumber = (this.addEmployeeForm.controls['invitedUser'] as UntypedFormGroup).controls['registeredNumber'];
    inviteNumber.valueChanges.subscribe(data => 
      {
        console.log("control is", inviteNumber);
        if (inviteNumber.valid) {
          this.checkIfNotDuplicate();
        }else{
          this.isNotDuplicateEmployee = false;
        }
      }
    );
    this.activAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
        this.activeAccount = param;
        this.accountStatus = this.activeAccount.account.accountStatus;
        let configData = null;
        if (this.config && this.config.data) {
          configData = this.config.data;
          if(configData && configData.mode && configData.mode == 'edit'){
            this.inEditMode = true;
            this.memberToEdit = configData.memberToEdit;
            console.log("member to edit is ", this.memberToEdit);
            if(this.memberToEdit == null)
              this.toastr.error('No Member Selected');
            else{
              this.allPropertiesSubscription = this.dataService.getMapAllCustomProperties().subscribe((param_prop: any) => {
                if (param_prop) {
                  this.allCustomProps = param_prop;
                  let allProps: CustomPropertyDefinitions[] = _.values(param_prop);
                  this.customProperties = allProps.filter(item => item.parentObjectType.toLowerCase() == 'user' && item.isSystemProperty == false && item.isArchived != true);
                }
              })
            }
              this.patchEditMemberValue();
          }
        }
      }
    });

    this.authorizations = globalFunctions.getObjectsFromEnum(AuthorizationLevel)
  }

  customFormValue(ev){
    this.customAttributes = ev;
  }
  

  ngOnDestroy(): void {
    if (this.activAccountSubscription && !this.activAccountSubscription.closed)
      this.activAccountSubscription.unsubscribe();
    if (this.allPropertiesSubscription && !this.allPropertiesSubscription.closed)
      this.allPropertiesSubscription.unsubscribe();
  }

  patchEditMemberValue(){
    const memberDetail: UntypedFormGroup = (this.addEmployeeForm as UntypedFormGroup);
    const invitedUserDetail: UntypedFormGroup = (this.addEmployeeForm.get('invitedUser') as UntypedFormGroup);
    
    invitedUserDetail.patchValue({
      registeredNumber: this.memberToEdit.user.registeredNumber,
      registeredEmail: this.memberToEdit.user.registeredEmail
    });

    memberDetail.patchValue({
      invitedUserAuthorizationLevel: this.memberToEdit.authorizationLevel
    });
  }

  async onSubmitInviteForm(event) {
    event.preventDefault();
    this.formSubmitted = true;
    console.log('On Submit Invite Form', this.addEmployeeForm.value);
    let formValue = cloneDeep(this.addEmployeeForm.value);
    if(!this.inEditMode){
    let payload = <InviteUserInput>{};
    payload.invitedUser = <CreateUserInput>{};
    payload.invitedUser.registeredNumber = formValue.invitedUser.registeredNumber.e164Number;
    payload.invitedUser.registeredEmail = formValue.invitedUser.registeredEmail;
    payload.invitedUserAuthorizationLevel = formValue.invitedUserAuthorizationLevel;
    payload["inviteeAccountId"] = this.activeAccount.accountId;
    payload.invitedUser.name = "";
    var outcome = null;
    this.api.InviteUser(payload).then(event => {
      outcome = event;
      console.log('User Invited to team account : ', event);
      this.data.changeMessageProfilePic();
      if(this.activeAccount.authorizationLevel == AuthorizationLevel.SUPERADMIN || this.activeAccount.authorizationLevel == AuthorizationLevel.ADMIN)
        this.toastr.success('User Successfully Invited to team account');
      if(this.activeAccount.authorizationLevel == AuthorizationLevel.MANAGER)
        this.toastr.success('Your Invite Request has been sent to Admins for approval', 'User Invited to team account');
      this.dialog.close(outcome);
    })
      .catch(e => {
        console.log('error inviting user to team account', e);
        this.showErrorInToastr(e, 'Error Inviting User')
        this.dialog.close(outcome);
      });
    }else{
      let formValue = this.addEmployeeForm.value
      if(this.memberToEdit.authorizationLevel != formValue.invitedUserAuthorizationLevel){
        let input = <UpdateAccountMembershipInput>{};
        input.updateAction = UpdateAccountMembershipAction.UPDATE_ROLE_DESIGNATION;
        input.id = this.memberToEdit.id;
        input.authorizationLevel = formValue.invitedUserAuthorizationLevel;
        if(this.memberToEdit.authorizationLevel == AuthorizationLevel.SUPERADMIN){
          //confirm if there is any other super admin in account
          let f = <ModelAccountMembershipFilterInput>{};
          f.authorizationLevel = {eq : AuthorizationLevel.SUPERADMIN}
          await fetchAllUsersByAccount(this.api, this.activeAccount.accountId, { filter: f }).then(users => {
            if(users){
              let allMembers = users as AccountMembership[];
              let count = allMembers.filter(obj => obj.authorizationLevel == AuthorizationLevel.SUPERADMIN).length;
              if(count == 1){
                this.toastr.error("You are the only Superadmin in account. The authorization level can not be changed unless someone else is made Superadmin.")
                return;
              }
            }
          })
            .catch(e => {
              console.log('error fetching members', e);
            });
        }

        // Confirm authorization change — it affects data visibility
        const fromLevel = this.memberToEdit.authorizationLevel;
        const toLevel = formValue.invitedUserAuthorizationLevel;
        const confirmResult = await Swal.fire({
          icon: 'warning',
          title: 'Change authorization level?',
          html: `Authorization is being changed from <b>${fromLevel}</b> to <b>${toLevel}</b>.<br/><br/>This will impact the data this user can see and act on, as per the new authorization.`,
          showCancelButton: true,
          confirmButtonText: 'Confirm change',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#1976d2',
          reverseButtons: true,
        });
        if (!confirmResult.isConfirmed) {
          return;
        }

        await this.api.UpdateAccountMembership(input).then(event => {
          outcome = event;
          console.log('User Authorization Level Changed : ', event);
          this.toastr.success('Authorization Level Changed', 'Authorization Level of Member is modified');
          
        })
          .catch(e => {
            console.log('error modifying membership', e);
            this.showErrorInToastr(e, 'Error Modifying Membership')
            this.dialog.close(outcome);
          });
      }
      if(this.customAttributes){
          let i = <UpdateAccountMembershipInput>{};
          i.id = this.memberToEdit.id;
          i.customMemberAttributes = JSON.stringify(this.customAttributes);
          await this.api.UpdateAccountMembershipData(i).then(event => {
            outcome = event;
            console.log('Custom attributes of member changed : ', event);
            this.toastr.success('Custom Attributes Updated', 'Custom attributes of member changed');
            this.dialog.close(event);
          })
            .catch(e => {
              console.log('error modifying membership', e);
              this.showErrorInToastr(e, 'Error Modifying Membership')
              this.dialog.close(outcome);
            });
      }
      else{
        this.dialog.close(outcome);
      }
    }
  }

  onResetInviteUser() {
    this.isNotDuplicateEmployee = false;
    this.addEmployeeForm.reset();
  }

  inviteMultiple(){
    this.dialog.close();
    this.sidebarService.open(AddEmployeeBulkComponent, {
      data: {  }
    }, 1);
  }

  getRegisteredNumberControl() {
    return (this.addEmployeeForm.get('invitedUser').get('registeredNumber') as UntypedFormControl);
  }

  getErrorInvitedUserNumber(control: UntypedFormControl) {
    return control.hasError('required') ? 'Field is required' :
      control.hasError('pattern') ? 'Not a valid contact Number' :
        control.hasError('alreadyInUse') ? 'This number is already associated with this account' : '';
  }


  getErrorInvitedUserEmail(control: UntypedFormControl) {
    return control.hasError('required') ? 'Field is required' :
      control.hasError('pattern') ? 'Not a valid email address' :
        control.hasError('alreadyInUse') ? 'This email id is already in use' : '';
  }

  getErrorInvitedUserName() {

  }

  getErrorDesignation() { }

  getErrorInvitedUserAuthorization() { }

  onChange(e){
    console.log(e);
  }
  
  toggle(selection : string){
    this.addEmployeeForm.controls['invitedUserAuthorizationLevel'].setValue(selection);
  }

  verifyAccount(){
    this.auth.verifyEmail();
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        console.log(e.errors[_i].message);
      }
    }
  }

}

